<fieldset [formGroup]="group" class="in-one-column">
  <legend class="mb-0 pb-0">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- Juice properties subform -->
  <ng-container *ngIf="getCtrl('juiceProperties')">
    <app-juice-properties-subform
      [groupName]="'juiceProperties'"
      class="w-100"
    ></app-juice-properties-subform>
  </ng-container>
  <!-- !Juice properties subform -->

  <!-- Coffee properties subform -->
  <ng-container *ngIf="getCtrl('coffeeProperties')">
    <app-coffee-properties-subform
      [groupName]="'coffeeProperties'"
      class="w-100"
    ></app-coffee-properties-subform>
  </ng-container>
  <!-- !Coffee properties subform -->

  <!-- Mineral water properties subform -->
  <ng-container *ngIf="getCtrl('mineralWaterProperties')">
    <app-mineral-water-properties-subform
      [groupName]="'mineralWaterProperties'"
      class="w-100"
    ></app-mineral-water-properties-subform>
  </ng-container>
  <!-- !Mineral water properties subform -->

  <!-- Soda pop properties subform -->
  <ng-container *ngIf="getCtrl('sodaPopProperties')">
    <app-soft-drink-properties-subform
      [groupName]="'sodaPopProperties'"
      class="w-100"
    ></app-soft-drink-properties-subform>
  </ng-container>
  <!-- !Soda pop properties subform -->

  <!-- Ice tea properties subform -->
  <ng-container *ngIf="getCtrl('iceTeaProperties')">
    <app-soft-drink-properties-subform
      [groupName]="'iceTeaProperties'"
      class="w-100"
    ></app-soft-drink-properties-subform>
  </ng-container>
  <!-- !Ice tea properties subform -->

  <!-- Cocktail syrup properties subform -->
  <ng-container *ngIf="getCtrl('cocktailSyrupProperties')">
    <app-cocktail-syrup-properties-subform
      [groupName]="'cocktailSyrupProperties'"
      class="w-100"
    ></app-cocktail-syrup-properties-subform>
  </ng-container>
  <!-- !Cocktail syrup properties subform -->

  <!-- Energy drink properties subform -->
  <ng-container *ngIf="getCtrl('energyDrinkProperties')">
    <app-energy-drink-properties-subform
      [groupName]="'energyDrinkProperties'"
      class="w-100"
    ></app-energy-drink-properties-subform>
  </ng-container>
  <!-- !Energy drink properties subform -->

  <!-- Syrup properties subform -->
  <ng-container *ngIf="getCtrl('syrupProperties')">
    <app-syrup-properties-subform
      [groupName]="'syrupProperties'"
      class="w-100"
    ></app-syrup-properties-subform>
  </ng-container>
  <!-- !Syrup properties subform -->

  <!-- Tea properties subform -->
  <ng-container *ngIf="getCtrl('teaProperties')">
    <app-tea-properties-subform
      [groupName]="'teaProperties'"
      class="w-100"
    ></app-tea-properties-subform>
  </ng-container>
  <!-- !Tea properties subform -->
</fieldset>
